<template>
  <div class="document-dates">
    <ul>
      <li :class="{active: date == isActive}" @click="onDateChange(date); isActive = date" v-bind:key="date"
          v-for="date in dates">
        {{ date }}
      </li>
    </ul>
    <select @change="onDateChange($event)" id="date-filter" name="date-filter">
      <option :value="date" v-bind:key="date" v-for="date in dates">{{ date }}</option>
    </select>
  </div>
</template>

<script>
  export default {
    name: 'documentDates',
    data() {
      return {
        isActive: new Date().getFullYear()
      }
    },
    mounted() {
      this.onDateChange(new Date().getFullYear())
    },
    computed: {
      dates() {
        const year = new Date().getFullYear();

        var years = [year];

        for (let i = 1; i < 8; i++) {
          years.push(year - i);

        }
        return years
      }
    },
    methods: {
      onDateChange: function (date) {
        if (date.type === 'change') {
          date = parseInt(event.target.value)
        }

        this.$root.setFilter('date', date)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  ul {
    list-style: none;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0;
    margin: 0;

    @media (max-width: 767px) {
      display: none;
    }

    li {
      position: relative;
      display: inline-block;
      color: #4678A2;
      font-size: 3rem;
      font-weight: 600;
      padding: 2rem 1rem;
      transition: all 0.1s ease-in-out;

      &:hover, &.active {
        color: #C7AE6F;
        cursor: pointer;

        &::after {
          content: '';
          width: 30px;
          height: 3px;
          background: #C7AE6F;
          display: block;
          left: 50%;
          bottom: 1rem;
          transform: translateX(-50%);
          position: absolute;
        }
      }
    }
  }

  select {
    display: none;
    border: none;
    font-size: 1.6rem;
    color: #19314A;
    padding: 0.5rem 0 1rem;
    border-bottom: solid 1px #727272;
    outline: none;

    @media (max-width: 767px) {
      display: block;
      width: auto;
      max-width: 100%;
    }
  }
</style>
